import {
  SlBadge
} from "./chunk.AQLP63PT.js";

// src/components/badge/badge.ts
var badge_default = SlBadge;
SlBadge.define("sl-badge");

export {
  badge_default
};
